module.exports = __webpack_public_path__ + "assets/urendeclareren6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren6.jpg
// module id = 370
// module chunks = 0